import {differenceInBusinessDays, isValid, parse} from "date-fns";
import {FormField, majorScale, Text, TextInput, TextInputProps} from 'evergreen-ui';
import React, {forwardRef, memo} from 'react';
import {FieldError} from 'react-hook-form';
import {ESBA_DATE_FORMAT} from '../index';
import {ValidationMessage} from './ValidationMessage';

type DatePickerCustomInputProps = {
    label: React.ReactNode;
    fieldName: string;
    value?: string;
    error?: FieldError;
    showDifferenceInBusinessDays?: boolean;
} & TextInputProps;
export const DatePickerCustomInput = memo(forwardRef<HTMLInputElement, DatePickerCustomInputProps>(
    ({
         label,
         fieldName,
         value,
         error,
         showDifferenceInBusinessDays = true,
         ...rest
     },
     ref,) => {
        const selectedDate: Date = parse(value ?? '', ESBA_DATE_FORMAT, new Date());
        return (
            <FormField
                marginBottom={24}
                label={label}
                validationMessage={<ValidationMessage error={error}/>}
                labelFor={fieldName}
            >
                <TextInput
                    id={fieldName}
                    value={value}
                    height={majorScale(4)}
                    isInvalid={!!error?.message}
                    ref={ref}
                    {...rest}
                />
                {isValid(selectedDate) && showDifferenceInBusinessDays &&
                <Text marginLeft={8}>
                    in {<b>{differenceInBusinessDays(selectedDate, new Date())}</b>} business
                    day(s)
                </Text>
                }
            </FormField>
        );
    }));
